@if ({user: authStatus.authenticatedUser$ | async}; as ctx) {
  <ng-container *transloco="let t">
    @if (!ctx.user?.authenticatedUser) {
      <cft-tab-pill [link]="loginLink" data-testid="login">
        <fa-icon [icon]="loginIcon" />
        {{ t('navbar.login') }}
      </cft-tab-pill>
    }
    @if (ctx.user?.authenticatedUser; as u) {
      @let prioritizedRole = u | bgoPrioritizedUserRole;
      <cft-tab-pill [link]="userLink(ctx.user?.authenticatedUser)">
        <div
          class="profile"
          [class.cursor-pointer]="ctx.user?.authenticatedUser?.pro || ctx.user?.authenticatedUser?.client"
          [class.cursor-not-allowed]="!ctx.user?.authenticatedUser?.pro && !ctx.user?.authenticatedUser?.client"
          [title]="t('navbar.profile')"
          data-testid="profile"
          [ngClass]="{
            'profile--admin': prioritizedRole === 'admin',
            'profile--pro': prioritizedRole === 'pro',
            'profile--agent': prioritizedRole === 'agent',
            'profile--client': prioritizedRole === 'client',
          }"
        >
          @if (u | bgoInitials; as initials) {
            <span>{{ initials }}</span>
          } @else {
            🛠
          }
        </div>
      </cft-tab-pill>
    }
  </ng-container>
}
